import React, { Component } from 'react'
import {
  getProjects,
} from '../../store/ducks/humanResources'
import { getOikosId, getProductsByRespId } from '../../utils/fc/index'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Link, Redirect } from 'react-router-dom'
import {
  Container, Row, Col, Card, CardBody, Media, Button, Modal, ModalHeader, ModalBody, ModalFooter,
  FormGroup, Label, Input, Table,
  Spinner,
} from 'reactstrap'
import moment from 'moment'
import Select from '../../components/Template/Input/Select'
import Breadcrumbs from '../../components/Common/Breadcrumb'

class ProductsApprovement extends Component {
  constructor(props) {
    super(props)
    this.state = {
      userOikosId: null,
    }
  }

  componentDidMount() {
    this.preloading()
  }

  preloading = async () => {
    const allProductsOfResp = await getProductsByRespId(this.props.userOikosId)
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth(); // 0-11
    const currentYear = currentDate.getFullYear();

    const filteredData = allProductsOfResp.filter(product => {
      const itemDate = new Date(product.prod_dtInterna);
      return itemDate.getMonth() === currentMonth &&
            itemDate.getFullYear() === currentYear &&
            !product.prodAprovacaoData;
    });
    this.setState({productsOfResp: filteredData})
  }

  render() {

    return (
      <Card>
        <CardBody>
          <Row className="d-flex justify-content-between">
            <Col>
              <h4 className="card-title mb-4">Minhas Aprovações</h4>
            </Col>
          </Row>
            {this.state.productsOfResp ?
              this.state.productsOfResp.map(p => (
                <>
                  <div style={{
                    color: (new Date() >= new Date(`${p.prod_dtLimAprov}T00:00:00-03:00`).setDate(new Date(`${p.prod_dtLimAprov}T00:00:00-03:00`).getDate() - 4) && new Date().getDate() <= new Date(`${p.prod_dtLimAprov}T00:00:00-03:00`).getDate()) ? "#fcb92c" :
                    new Date() > new Date(`${p.prod_dtLimAprov}T00:00:00-03:00`) ? "red" : ""
                  }}>
                    <span style={{fontWeight: "bold"}}>Projeto: </span><span>{p.proj_nome}</span><br />
                    <span style={{fontWeight: "bold"}}>Produto: </span><span>{p.prod_desc}</span><br />
                    <span style={{fontWeight: "bold"}}>Limite Aprov: </span><span>{moment(p.prod_dtLimAprov).format("DD/MM/YYYY")}</span>
                  </div>
                  <br />
                  <br />
                </>
              )) :
              <div className='d-flex justify-content-center align-items-center'>
                <Spinner />
              </div>
              }
        </CardBody>
      </Card>
    )
  }
}

const mapStateToProps = state => ({
  auth: state.auth,
  humanResources: state.humanResources,
})
const mapDispatchToProps = dispatch => bindActionCreators({
  getProjects,
}, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(ProductsApprovement)
